import { ref, watch } from 'vue'

/**
 * Which brand's customers the console shows (2026-10-14) — `core/brands.py`.
 *
 * Every request carries it as `X-Brand` (the interceptor in `api/index.ts`) and
 * the admin backend filters by it (`admin/backend/brand_view.py`). App.vue keys
 * the routed view on it, so switching re-mounts the page and every screen
 * refetches without each one having to watch this.
 *
 * A view, not a permission: every operator may pick every view. Remembered per
 * browser like the language.
 */
export type BrandView = 'all' | 'tothor' | '1cards'
export type Brand = Exclude<BrandView, 'all'>

export const BRAND_VIEWS: { code: BrandView; label: string }[] = [
  { code: 'all', label: 'brand.all' },
  { code: 'tothor', label: 'brand.tothor' },
  { code: '1cards', label: 'brand.1cards' },
]

const KEY = 'tothor.ops.brand'

function initial(): BrandView {
  try {
    const s = localStorage.getItem(KEY)
    return s === 'tothor' || s === '1cards' ? s : 'all'
  } catch {
    return 'all'
  }
}

export const brandView = ref<BrandView>(initial())

watch(brandView, (b) => {
  try {
    localStorage.setItem(KEY, b)
  } catch {
    /* private window — the choice lasts this tab only */
  }
})

/** Display name of a customer's brand. */
export const brandName = (b: string | null | undefined) => (b === '1cards' ? '1cards' : 'Tothor')
